// import { 
//   Box, 
//   Container, 
//   Typography, 
//   Grid, 
//   Card,
//   List,
//   ListItem,
//   ListItemIcon,
//   ListItemText,
//   Stack,
//   Button,
//   Paper,
//   Chip
// } from '@mui/material';
// import {
//   Payment as PaymentIcon,
//   Lock as LockIcon,
//   Groups as GroupsIcon,
//   TrendingUp as TrendingIcon,
//   Receipt as ReceiptIcon,
//   CheckCircle as CheckIcon,
//   Gavel as LegalIcon,
//   Category as CategoryIcon,
//   Archive as ArchiveIcon,
//   Security as SecurityIcon,
//   Search as SearchIcon,
//   PictureAsPdf as PdfIcon,
//   BarChart as ChartIcon,
//   CardMembership as MembershipIcon,
//   MonetizationOn as MoneyIcon,
//   Notifications as NotificationIcon
// } from '@mui/icons-material';
// import { useState } from 'react';

// const SubscriptionPage = () => {
//   const [hoveredCard, setHoveredCard] = useState(null);

//   // Abonelik Sistemi Özellikleri
//   const subscriptionFeatures = [
//     {
//       icon: <MembershipIcon sx={{ fontSize: 50 }} />,
//       title: "Abonelik Paketleri",
//       description: "Farklı seviye paketler oluşturun ve yönetin",
//       color: "#1e40af",
//       gradient: "linear-gradient(135deg, #1e40af 0%, #3b82f6 100%)",
//       items: [
//         "Çoklu abonelik paketleri",
//         "Esnek fiyatlandırma",
//         "Aylık/Yıllık seçenekler",
//         "Deneme süresi desteği"
//       ]
//     },
//     {
//       icon: <GroupsIcon sx={{ fontSize: 50 }} />,
//       title: "Abone Yönetimi",
//       description: "Kapsamlı abone takibi ve yönetimi",
//       color: "#dc2626",
//       gradient: "linear-gradient(135deg, #dc2626 0%, #ef4444 100%)",
//       items: [
//         "Abone profil yönetimi",
//         "Abonelik geçmişi",
//         "Otomatik yenileme",
//         "İptal ve iade yönetimi"
//       ]
//     },
//     {
//       icon: <LockIcon sx={{ fontSize: 50 }} />,
//       title: "Premium İçerik",
//       description: "Sadece abonelere özel içerik kilitleme",
//       color: "#059669",
//       gradient: "linear-gradient(135deg, #059669 0%, #10b981 100%)",
//       items: [
//         "İçerik kilitleme sistemi",
//         "Paywall yönetimi",
//         "Kısmi içerik gösterimi",
//         "Esnekçünkü görünürlük kontrolü"
//       ]
//     },
//     {
//       icon: <PaymentIcon sx={{ fontSize: 50 }} />,
//       title: "Ödeme Entegrasyonu",
//       description: "Güvenli ödeme altyapısı",
//       color: "#7c3aed",
//       gradient: "linear-gradient(135deg, #7c3aed 0%, #8b5cf6 100%)",
//       items: [
//         "Kredi kartı entegrasyonu",
//         "Online ödeme sistemleri",
//         "Güvenli ödeme gateway",
//         "3D Secure desteği"
//       ]
//     },
//     {
//       icon: <ChartIcon sx={{ fontSize: 50 }} />,
//       title: "Abonelik Raporları",
//       description: "Detaylı analiz ve raporlama",
//       color: "#ea580c",
//       gradient: "linear-gradient(135deg, #ea580c 0%, #f97316 100%)",
//       items: [
//         "Gelir raporları",
//         "Abone analitiği",
//         "Davranış analizi",
//         "Churn rate takibi"
//       ]
//     },
//     {
//       icon: <NotificationIcon sx={{ fontSize: 50 }} />,
//       title: "Otomatik Bildirimler",
//       description: "E-posta ve SMS bildirimleri",
//       color: "#0891b2",
//       gradient: "linear-gradient(135deg, #0891b2 0%, #06b6d4 100%)",
//       items: [
//         "Hoş geldin e-postaları",
//         "Ödeme hatırlatıcıları",
//         "Abonelik bitim bildirimleri",
//         "Özel içerik duyuruları"
//       ]
//     }
//   ];

//   // BİK Özellikleri
//   const bikFeatures = [
//     {
//       icon: <LegalIcon sx={{ fontSize: 45 }} />,
//       title: "BİK Standartları",
//       description: "Resmi ilan yayını standartlarına %100 uyum",
//       color: "#1e40af"
//     },
//     {
//       icon: <CategoryIcon sx={{ fontSize: 45 }} />,
//       title: "İlan Yönetimi",
//       description: "Resmi ilan kategorilendirme ve yönetim sistemi",
//       color: "#dc2626"
//     },
//     {
//       icon: <ChartIcon sx={{ fontSize: 45 }} />,
//       title: "BİK Raporlama",
//       description: "BİK uyumlu raporlama ve döküm sistemi",
//       color: "#059669"
//     },
//     {
//       icon: <SecurityIcon sx={{ fontSize: 45 }} />,
//       title: "Güvenlik",
//       description: "Resmi ilan güvenlik standartları",
//       color: "#7c3aed"
//     },
//     {
//       icon: <ArchiveIcon sx={{ fontSize: 45 }} />,
//       title: "Arşivleme",
//       description: "Yasal sürelere uygun arşivleme sistemi",
//       color: "#ea580c"
//     },
//     {
//       icon: <SearchIcon sx={{ fontSize: 45 }} />,
//       title: "İlan Arama",
//       description: "Gelişmiş ilan arama ve filtreleme",
//       color: "#0891b2"
//     }
//   ];

//   return (
//     <Box>
//       {/* Hero Section */}
//       <Box
//         sx={{
//           py: { xs: 10, md: 16 },
//           background: `
//             linear-gradient(
//               135deg,
//               #7c3aed 0%,
//               #8b5cf6 50%,
//               #a78bfa 100%
//             )
//           `,
//           position: 'relative',
//           overflow: 'hidden',
//           color: 'white',
//           '&::before': {
//             content: '""',
//             position: 'absolute',
//             top: 0,
//             left: 0,
//             right: 0,
//             bottom: 0,
//             background: `
//               radial-gradient(circle at 20% 20%, rgba(255, 255, 255, 0.15) 0%, transparent 50%),
//               radial-gradient(circle at 80% 80%, rgba(255, 255, 255, 0.15) 0%, transparent 50%)
//             `,
//             pointerEvents: 'none'
//           }
//         }}
//       >
//         <Container maxWidth="xl">
//           <Box sx={{ textAlign: 'center', position: 'relative', zIndex: 1 }}>
//             <Box
//               sx={{
//                 display: 'inline-flex',
//                 alignItems: 'center',
//                 justifyContent: 'center',
//                 width: 100,
//                 height: 100,
//                 borderRadius: '50%',
//                 background: 'rgba(255, 255, 255, 0.2)',
//                 backdropFilter: 'blur(10px)',
//                 mb: 4,
//                 mx: 'auto'
//               }}
//             >
//               <MoneyIcon sx={{ fontSize: 60, color: 'white' }} />
//             </Box>

//             <Typography
//               variant="overline"
//               sx={{
//                 fontSize: '0.9rem',
//                 fontWeight: 900,
//                 letterSpacing: '0.15em',
//                 color: 'rgba(255,255,255,0.9)',
//                 mb: 2,
//                 display: 'block',
//                 textTransform: 'uppercase'
//               }}
//             >
//               ABONELİK VE GELİR MODELİ
//             </Typography>

//             <Typography
//               variant="h1"
//               sx={{
//                 fontSize: { xs: '2.5rem', md: '4.5rem' },
//                 fontWeight: 800,
//                 mb: 4,
//                 color: 'white',
//                 fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, sans-serif',
//                 lineHeight: 1.1
//               }}
//             >
//               Sürdürülebilir Gelir Modeli
//             </Typography>

//             <Typography
//               variant="h5"
//               sx={{
//                 fontSize: { xs: '1.2rem', md: '1.5rem' },
//                 color: 'rgba(255,255,255,0.9)',
//                 maxWidth: 800,
//                 mx: 'auto',
//                 lineHeight: 1.6,
//                 fontWeight: 400,
//                 mb: 6
//               }}
//             >
//               Abonelik sistemi ve BİK uyumlu resmi ilan yayını ile çoklu gelir kaynağı oluşturun
//             </Typography>

//             <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} justifyContent="center">
//               <Button
//                 variant="contained"
//                 size="large"
//                 sx={{
//                   background: 'white',
//                   color: '#7c3aed',
//                   px: 5,
//                   py: 2,
//                   fontSize: '1.1rem',
//                   fontWeight: 600,
//                   borderRadius: 2,
//                   textTransform: 'none',
//                   '&:hover': {
//                     background: '#f8fafc',
//                     transform: 'translateY(-2px)',
//                     boxShadow: '0 10px 30px rgba(0, 0, 0, 0.2)'
//                   },
//                   transition: 'all 0.3s ease'
//                 }}
//               >
//                 Gelir Modelleri
//               </Button>
//               <Button
//                 variant="outlined"
//                 size="large"
//                 sx={{
//                   borderColor: 'white',
//                   color: 'white',
//                   px: 5,
//                   py: 2,
//                   fontSize: '1.1rem',
//                   fontWeight: 600,
//                   borderRadius: 2,
//                   borderWidth: 2,
//                   textTransform: 'none',
//                   '&:hover': {
//                     borderWidth: 2,
//                     background: 'rgba(255, 255, 255, 0.1)',
//                     transform: 'translateY(-2px)'
//                   },
//                   transition: 'all 0.3s ease'
//                 }}
//               >
//                 BİK Uyumluluğu
//               </Button>
//             </Stack>
//           </Box>
//         </Container>
//       </Box>

//       {/* Abonelik Sistemi */}
//       <Box sx={{ py: { xs: 10, md: 16 }, background: '#f8fafc' }}>
//         <Container maxWidth="xl">
//           <Box sx={{ textAlign: 'center', mb: 10 }}>
//             <Typography
//               variant="h2"
//               sx={{
//                 fontSize: { xs: '2.5rem', md: '3.5rem' },
//                 fontWeight: 800,
//                 mb: 3,
//                 background: 'linear-gradient(135deg, #1e293b 0%, #7c3aed 100%)',
//                 backgroundClip: 'text',
//                 WebkitBackgroundClip: 'text',
//                 WebkitTextFillColor: 'transparent'
//               }}
//             >
//               Güçlü Abonelik Sistemi
//             </Typography>
//             <Typography
//               variant="h6"
//               sx={{
//                 color: '#64748b',
//                 maxWidth: 700,
//                 mx: 'auto',
//                 lineHeight: 1.6
//               }}
//             >
//               Premium içerik ve sürdürülebilir gelir için eksiksiz çözüm
//             </Typography>
//           </Box>

//           <Grid container spacing={4}>
//             {subscriptionFeatures.map((feature, index) => (
//               <Grid item xs={12} md={6} lg={4} key={index}>
//                 <Paper
//                   elevation={0}
//                   onMouseEnter={() => setHoveredCard(index)}
//                   onMouseLeave={() => setHoveredCard(null)}
//                   sx={{
//                     p: 5,
//                     height: '100%',
//                     background: 'white',
//                     border: '1px solid #e2e8f0',
//                     borderRadius: 4,
//                     cursor: 'pointer',
//                     transition: 'all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1)',
//                     position: 'relative',
//                     overflow: 'hidden',
//                     '&::before': {
//                       content: '""',
//                       position: 'absolute',
//                       top: 0,
//                       left: 0,
//                       right: 0,
//                       height: 4,
//                       background: feature.gradient,
//                       transform: hoveredCard === index ? 'scaleX(1)' : 'scaleX(0)',
//                       transformOrigin: 'left',
//                       transition: 'transform 0.3s ease'
//                     },
//                     '&:hover': {
//                       transform: 'translateY(-8px)',
//                       boxShadow: `0 20px 40px ${feature.color}20`,
//                       borderColor: feature.color
//                     }
//                   }}
//                 >
//                   <Box
//                     sx={{
//                       display: 'inline-flex',
//                       alignItems: 'center',
//                       justifyContent: 'center',
//                       width: 80,
//                       height: 80,
//                       borderRadius: 3,
//                       background: `${feature.color}15`,
//                       color: feature.color,
//                       mb: 3,
//                       transition: 'all 0.4s ease',
//                       transform: hoveredCard === index ? 'scale(1.1) rotate(5deg)' : 'scale(1)'
//                     }}
//                   >
//                     {feature.icon}
//                   </Box>

//                   <Typography
//                     variant="h5"
//                     sx={{
//                       fontWeight: 700,
//                       mb: 2,
//                       color: '#1e293b',
//                       fontSize: '1.3rem'
//                     }}
//                   >
//                     {feature.title}
//                   </Typography>

//                   <Typography
//                     variant="body1"
//                     sx={{
//                       color: '#64748b',
//                       lineHeight: 1.7,
//                       mb: 3
//                     }}
//                   >
//                     {feature.description}
//                   </Typography>

//                   <List dense>
//                     {feature.items.map((item, idx) => (
//                       <ListItem key={idx} sx={{ px: 0, py: 0.5 }}>
//                         <ListItemIcon sx={{ minWidth: 32 }}>
//                           <CheckIcon sx={{ color: feature.color, fontSize: 20 }} />
//                         </ListItemIcon>
//                         <ListItemText
//                           primary={item}
//                           primaryTypographyProps={{
//                             fontSize: '0.95rem',
//                             color: '#475569',
//                             fontWeight: 500
//                           }}
//                         />
//                       </ListItem>
//                     ))}
//                   </List>
//                 </Paper>
//               </Grid>
//             ))}
//           </Grid>
//         </Container>
//       </Box>

//       {/* BİK Uyumluluğu */}
//       <Box
//         sx={{
//           py: { xs: 10, md: 16 },
//           background: 'linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%)',
//           color: 'white'
//         }}
//       >
//         <Container maxWidth="xl">
//           <Box sx={{ textAlign: 'center', mb: 10 }}>
//             <Box
//               sx={{
//                 display: 'inline-flex',
//                 alignItems: 'center',
//                 justifyContent: 'center',
//                 width: 80,
//                 height: 80,
//                 borderRadius: 3,
//                 background: 'rgba(255, 255, 255, 0.1)',
//                 backdropFilter: 'blur(10px)',
//                 mb: 4,
//                 mx: 'auto'
//               }}
//             >
//               <LegalIcon sx={{ fontSize: 50, color: 'white' }} />
//             </Box>
//             <Typography
//               variant="h2"
//               sx={{
//                 fontSize: { xs: '2.5rem', md: '3.5rem' },
//                 fontWeight: 800,
//                 mb: 3,
//                 color: 'white'
//               }}
//             >
//               Basın İlan Kurumu Uyumluluğu
//             </Typography>
//             <Typography
//               variant="h6"
//               sx={{
//                 color: 'rgba(255,255,255,0.8)',
//                 maxWidth: 700,
//                 mx: 'auto',
//                 lineHeight: 1.6,
//                 mb: 2
//               }}
//             >
//               Resmi ilan yayını ile ek gelir kaynağı oluşturun
//             </Typography>
//             <Chip
//               label="BİK Onaylı"
//               sx={{
//                 background: 'linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%)',
//                 color: 'white',
//                 fontWeight: 700,
//                 fontSize: '1rem',
//                 px: 2,
//                 py: 3
//               }}
//             />
//           </Box>

//           <Grid container spacing={4}>
//             {bikFeatures.map((feature, index) => (
//               <Grid item xs={12} sm={6} md={4} key={index}>
//                 <Card
//                   sx={{
//                     p: 4,
//                     height: '100%',
//                     background: 'rgba(255, 255, 255, 0.05)',
//                     backdropFilter: 'blur(10px)',
//                     border: '1px solid rgba(255, 255, 255, 0.1)',
//                     borderRadius: 3,
//                     textAlign: 'center',
//                     transition: 'all 0.3s ease',
//                     '&:hover': {
//                       background: 'rgba(255, 255, 255, 0.08)',
//                       transform: 'translateY(-5px)',
//                       boxShadow: '0 10px 30px rgba(0, 0, 0, 0.3)'
//                     }
//                   }}
//                 >
//                   <Box
//                     sx={{
//                       display: 'inline-flex',
//                       alignItems: 'center',
//                       justifyContent: 'center',
//                       width: 70,
//                       height: 70,
//                       borderRadius: 2,
//                       background: `${feature.color}30`,
//                       color: feature.color,
//                       mb: 3
//                     }}
//                   >
//                     {feature.icon}
//                   </Box>
//                   <Typography variant="h6" sx={{ fontWeight: 700, color: 'white', mb: 2 }}>
//                     {feature.title}
//                   </Typography>
//                   <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.7)', lineHeight: 1.6 }}>
//                     {feature.description}
//                   </Typography>
//                 </Card>
//               </Grid>
//             ))}
//           </Grid>
//         </Container>
//       </Box>

//       {/* CTA Section */}
//       <Box
//         sx={{
//           py: { xs: 10, md: 16 },
//           background: 'linear-gradient(135deg, #7c3aed 0%, #a78bfa 100%)',
//           color: 'white',
//           textAlign: 'center'
//         }}
//       >
//         <Container maxWidth="md">
//           <Typography
//             variant="h2"
//             sx={{
//               fontSize: { xs: '2.5rem', md: '3.5rem' },
//               fontWeight: 800,
//               mb: 3
//             }}
//           >
//             Gelir Modelinizi Çeşitlendirin
//           </Typography>
//           <Typography
//             variant="h6"
//             sx={{
//               mb: 6,
//               opacity: 0.95,
//               lineHeight: 1.6
//             }}
//           >
//             Abonelik sistemi ve resmi ilan yayını ile sürdürülebilir gelir elde edin
//           </Typography>
//           <Stack direction={{ xs: 'column', sm: 'row' }} spacing={3} justifyContent="center">
//             <Button
//               variant="contained"
//               size="large"
//               sx={{
//                 background: 'white',
//                 color: '#7c3aed',
//                 px: 6,
//                 py: 2.5,
//                 fontSize: '1.2rem',
//                 fontWeight: 700,
//                 borderRadius: 2,
//                 textTransform: 'none',
//                 '&:hover': {
//                   background: '#f8fafc',
//                   transform: 'translateY(-2px)',
//                   boxShadow: '0 10px 30px rgba(0, 0, 0, 0.2)'
//                 },
//                 transition: 'all 0.3s ease'
//               }}
//             >
//               Ücretsiz Deneyin
//             </Button>
//             <Button
//               variant="outlined"
//               size="large"
//               sx={{
//                 borderColor: 'white',
//                 color: 'white',
//                 px: 6,
//                 py: 2.5,
//                 fontSize: '1.2rem',
//                 fontWeight: 600,
//                 borderRadius: 2,
//                 borderWidth: 2,
//                 textTransform: 'none',
//                 '&:hover': {
//                   borderWidth: 2,
//                   background: 'rgba(255, 255, 255, 0.1)',
//                   transform: 'translateY(-2px)'
//                 },
//                 transition: 'all 0.3s ease'
//               }}
//             >
//               Daha Fazla Bilgi
//             </Button>
//           </Stack>
//         </Container>
//       </Box>
//     </Box>
//   );
// };

// export default SubscriptionPage;


import React, { useState } from 'react';
import {
  Box,
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  Button,
  Chip,
  Stack,
  Paper,
  Divider,
  Switch,
  IconButton,
  Avatar,
  List,
  ListItem,
  ListItemIcon,
  ListItemText
} from '@mui/material';
import {
  Payment as PaymentIcon,
  TrendingUp as TrendingIcon,
  Lock as LockIcon,
  Star as StarIcon,
  CheckCircle as CheckIcon,
  Close as CloseIcon,
  ArrowForward as ArrowIcon,
  Rocket as RocketIcon,
  Diamond as DiamondIcon,
  Bolt as BoltIcon,
  AttachMoney as MoneyIcon,
  AccountBalance as BankIcon,
  CreditCard as CardIcon,
  Receipt as ReceiptIcon,
  Analytics as AnalyticsIcon,
  Security as SecurityIcon,
  Gavel as LegalIcon,
  Description as DocumentIcon,
  AutoAwesome as MagicIcon,
  Verified as VerifiedIcon,
  LocalOffer as OfferIcon,
  CropTwoTone
} from '@mui/icons-material';

const SubscriptionRevenuePage = () => {
  const [billingPeriod, setBillingPeriod] = useState('monthly'); // monthly or yearly
  const [hoveredPlan, setHoveredPlan] = useState(null);
  const [hoveredFeature, setHoveredFeature] = useState(null);

  // Abonelik Paketleri
  const plans = [
    {
      id: 'starter',
      name: 'Başlangıç',
      icon: <BoltIcon />,
      color: '#3b82f6',
      gradient: 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)',
      price: { monthly: 1999, yearly: 19990 },
      description: 'Küçük haber siteleri için ideal',
      popular: false,
      features: [
        { text: '30 Widget Erişimi', included: true },
        { text: '5 Kullanıcı', included: true },
        { text: '10 GB Depolama', included: true },
        { text: 'E-posta Desteği', included: true },
        { text: 'Temel Analitik', included: true },
        { text: 'Mobil Responsive', included: true },
        { text: 'RSS Entegrasyonu', included: false },
        { text: 'BİK Uyumluluğu', included: false },
        { text: 'Abonelik Sistemi', included: false },
        { text: 'Özel Widget', included: false }
      ],
      cta: 'Başla',
      badge: null
    },
    {
      id: 'professional',
      name: 'Profesyonel',
      icon: <StarIcon />,
      color: '#10b981',
      gradient: 'linear-gradient(135deg, #10b981 0%, #047857 100%)',
      price: { monthly: 3999, yearly: 39990 },
      description: 'Orta ölçekli platformlar için',
      popular: true,
      features: [
        { text: '60 Widget Erişimi', included: true },
        { text: '20 Kullanıcı', included: true },
        { text: '50 GB Depolama', included: true },
        { text: 'Öncelikli Destek', included: true },
        { text: 'Gelişmiş Analitik', included: true },
        { text: 'Mobil Responsive', included: true },
        { text: 'RSS Entegrasyonu', included: true },
        { text: 'BİK Uyumluluğu', included: true },
        { text: 'Abonelik Sistemi', included: true },
        { text: 'Özel Widget', included: false }
      ],
      cta: 'Başla',
      badge: 'EN POPÜLER',
      savings: '%17 İndirim'
    },
    {
      id: 'enterprise',
      name: 'Kurumsal',
      icon: <CropTwoTone />,
      color: '#8b5cf6',
      gradient: 'linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)',
      price: { monthly: 7999, yearly: 79990 },
      description: 'Büyük haber kuruluşları için',
      popular: false,
      features: [
        { text: '70+ Tüm Widget\'lar', included: true },
        { text: 'Sınırsız Kullanıcı', included: true },
        { text: 'Sınırsız Depolama', included: true },
        { text: 'Özel Destek Ekibi', included: true },
        { text: 'Premium Analitik', included: true },
        { text: 'Mobil Responsive', included: true },
        { text: 'RSS Entegrasyonu', included: true },
        { text: 'BİK Uyumluluğu', included: true },
        { text: 'Abonelik Sistemi', included: true },
        { text: 'Özel Widget Geliştirme', included: true }
      ],
      cta: 'İletişime Geç',
      badge: 'KURUMSAL',
      savings: '%17 İndirim'
    }
  ];

  // Abonelik Sistemi Özellikleri
  const subscriptionFeatures = [
    {
      icon: <PaymentIcon />,
      title: 'Esnek Paket Yönetimi',
      description: 'Farklı seviye abonelik paketleri oluşturun ve yönetin',
      color: '#3b82f6',
      items: ['Aylık/Yıllık paketler', 'Özel fiyatlandırma', 'Deneme süreleri', 'Kupon sistemi']
    },
    {
      icon: <LockIcon />,
      title: 'Premium İçerik Kontrolü',
      description: 'Sadece abonelere özel içerikler sunun',
      color: '#10b981',
      items: ['İçerik kilitleme', 'Paywall sistemi', 'Önizleme modu', 'Abone takibi']
    },
    {
      icon: <CardIcon />,
      title: 'Güvenli Ödeme',
      description: 'Entegre ödeme altyapısı ile güvenli tahsilat',
      color: '#f59e0b',
      items: ['Kredi kartı', 'Banka transferi', '3D Secure', 'Otomatik fatura']
    },
    {
      icon: <AnalyticsIcon />,
      title: 'Gelir Raporları',
      description: 'Detaylı abonelik ve gelir analizleri',
      color: '#8b5cf6',
      items: ['Gelir grafikleri', 'Abone istatistikleri', 'Churn analizi', 'MRR/ARR raporları']
    }
  ];

  // BİK Özellikleri
  const bikFeatures = [
    {
      icon: <LegalIcon />,
      title: 'BİK Standartları',
      description: 'Basın İlan Kurumu standartlarına tam uyum',
      color: '#dc2626'
    },
    {
      icon: <DocumentIcon />,
      title: 'Resmi İlan Yönetimi',
      description: 'İlan kategorilendirme ve yayın sistemi',
      color: '#f59e0b'
    },
    {
      icon: <ReceiptIcon />,
      title: 'Otomatik Arşivleme',
      description: 'Yasal sürelere uygun arşivleme sistemi',
      color: '#10b981'
    },
    {
      icon: <AnalyticsIcon />,
      title: 'Detaylı Raporlama',
      description: 'BİK uyumlu raporlama ve dökümantasyon',
      color: '#8b5cf6'
    }
  ];

  // Ödeme Yöntemleri
  const paymentMethods = [
    { name: 'Kredi Kartı', icon: '💳', supported: true },
    { name: 'Banka Transferi', icon: '🏦', supported: true },
    { name: 'Havale/EFT', icon: '💸', supported: true },
    { name: 'PayPal', icon: '🅿️', supported: true },
    { name: 'Stripe', icon: '💠', supported: true },
    { name: 'iyzico', icon: '🔷', supported: true }
  ];

  return (
    <Box sx={{ position: 'relative', overflow: 'hidden' }}>
      
      {/* Hero Section */}
      <Box
        sx={{
          background: 'linear-gradient(135deg, #0f0f23 0%, #1a1a2e 100%)',
          pt: { xs: 12, md: 16 },
          pb: { xs: 10, md: 15 },
          position: 'relative',
          overflow: 'hidden'
        }}
      >
        {/* Animated Blobs */}
        <Box
          sx={{
            position: 'absolute',
            top: -150,
            right: -150,
            width: 500,
            height: 500,
            background: 'linear-gradient(135deg, #10b981 0%, #047857 100%)',
            borderRadius: '40% 60% 70% 30% / 40% 50% 60% 50%',
            opacity: 0.1,
            filter: 'blur(80px)',
            animation: 'morph 10s ease-in-out infinite'
          }}
        />

        <Container maxWidth="xl" sx={{ position: 'relative', zIndex: 2 }}>
          <Box sx={{ textAlign: 'center', mb: 8 }}>
            <Chip
              label="ABONELİK & GELİR MODELİ"
              icon={<MoneyIcon sx={{ fontSize: '1rem' }} />}
              sx={{
                background: 'linear-gradient(135deg, rgba(16, 185, 129, 0.2), rgba(4, 120, 87, 0.2))',
                color: '#10b981',
                border: '1px solid rgba(16, 185, 129, 0.3)',
                backdropFilter: 'blur(10px)',
                fontSize: '0.85rem',
                fontWeight: 600,
                mb: 3,
                px: 2,
                py: 2.5
              }}
            />
            
            <Typography
              variant="h1"
              sx={{
                fontSize: { xs: '2.5rem', md: '4.5rem' },
                fontWeight: 900,
                color: 'white',
                mb: 3,
                lineHeight: 1.1
              }}
            >
              Gelir Modelinizi{' '}
              <span style={{ 
                background: 'linear-gradient(135deg, #10b981 0%, #f59e0b 100%)',
                backgroundClip: 'text',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent'
              }}>
                Oluşturun
              </span>
            </Typography>

            <Typography
              variant="h5"
              sx={{
                color: 'rgba(255,255,255,0.7)',
                fontSize: { xs: '1.1rem', md: '1.4rem' },
                lineHeight: 1.6,
                mb: 5,
                maxWidth: 800,
                mx: 'auto'
              }}
            >
              Entegre abonelik sistemi ve BİK uyumluluğu ile gelir kaynaklarınızı çeşitlendirin
            </Typography>

            {/* Billing Toggle */}
            <Box
              sx={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 2,
                p: 1,
                borderRadius: '50px',
                background: 'rgba(255,255,255,0.1)',
                backdropFilter: 'blur(10px)',
                border: '1px solid rgba(255,255,255,0.2)'
              }}
            >
              <Typography
                sx={{
                  color: billingPeriod === 'monthly' ? 'white' : 'rgba(255,255,255,0.6)',
                  fontWeight: 700,
                  fontSize: '1rem',
                  px: 2
                }}
              >
                Aylık
              </Typography>
              <Switch
                checked={billingPeriod === 'yearly'}
                onChange={(e) => setBillingPeriod(e.target.checked ? 'yearly' : 'monthly')}
                sx={{
                  '& .MuiSwitch-switchBase.Mui-checked': {
                    color: '#10b981'
                  },
                  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                    backgroundColor: '#10b981'
                  }
                }}
              />
              <Stack direction="row" spacing={1} alignItems="center">
                <Typography
                  sx={{
                    color: billingPeriod === 'yearly' ? 'white' : 'rgba(255,255,255,0.6)',
                    fontWeight: 700,
                    fontSize: '1rem'
                  }}
                >
                  Yıllık
                </Typography>
                <Chip
                  label="%17 İndirim"
                  size="small"
                  sx={{
                    background: '#10b981',
                    color: 'white',
                    fontWeight: 700,
                    fontSize: '0.7rem',
                    height: 24
                  }}
                />
              </Stack>
            </Box>
          </Box>
        </Container>

        {/* Dalga Geçişi */}
        <Box
          sx={{
            position: 'absolute',
            bottom: 0,
            left: 0,
            width: '100%',
            overflow: 'hidden',
            lineHeight: 0,
            height : {xs:'100px !important', md :'250px !important'}
          }}
        >
          <svg
            viewBox="0 0 1440 400"
            preserveAspectRatio="none"
            style={{ width: '100%', height: 'auto', display: 'block' }}
          >
            <path
              d="M0,160L48,170.7C96,181,192,203,288,197.3C384,192,480,160,576,154.7C672,149,768,171,864,181.3C960,192,1056,192,1152,176C1248,160,1344,128,1392,112L1440,96L1440,400L0,400Z"
              fill="#f8f9fa"
            />
          </svg>
        </Box>
      </Box>

      {/* Abonelik Sistemi Özellikleri */}
      <Box
        sx={{
          background: 'white',
          py: { xs: 8, md: 12 }
        }}
      >
        <Container maxWidth="xl">
          <Box sx={{ textAlign: 'center', mb: 8 }}>
            <Typography
              variant="overline"
              sx={{
                color: '#10b981',
                fontSize: '0.9rem',
                fontWeight: 700,
                letterSpacing: '0.1em'
              }}
            >
              ABONELİK SİSTEMİ
            </Typography>
            <Typography
              variant="h2"
              sx={{
                fontSize: { xs: '2.5rem', md: '3.5rem' },
                fontWeight: 800,
                color: '#1a1a2e',
                mb: 2,
                mt: 2
              }}
            >
              Güçlü Abonelik Altyapısı
            </Typography>
            <Typography
              variant="h6"
              sx={{
                color: '#6c757d',
                maxWidth: 700,
                mx: 'auto'
              }}
            >
              Premium içerik sunun ve düzenli gelir elde edin
            </Typography>
          </Box>

          <Grid container spacing={4}>
            {subscriptionFeatures.map((feature, index) => (
              <Grid item xs={12} md={6} key={index}>
                <Card
                  sx={{
                    height: '100%',
                    borderRadius: 4,
                    border: '2px solid #e2e8f0',
                    overflow: 'hidden',
                    transition: 'all 0.3s ease',
                    '&:hover': {
                      borderColor: feature.color,
                      transform: 'translateY(-8px)',
                      boxShadow: `0 16px 40px ${feature.color}20`,
                      '& .feature-icon': {
                        background: feature.color,
                        color: 'white',
                        transform: 'scale(1.1) rotate(5deg)'
                      }
                    }
                  }}
                >
                  <CardContent sx={{ p: 4 }}>
                    <Stack direction="row" spacing={3} mb={3}>
                      <Box
                        className="feature-icon"
                        sx={{
                          width: 70,
                          height: 70,
                          borderRadius: 3,
                          background: `${feature.color}15`,
                          color: feature.color,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          fontSize: '2rem',
                          flexShrink: 0,
                          transition: 'all 0.3s ease',
                          boxShadow: `0 4px 16px ${feature.color}20`
                        }}
                      >
                        {feature.icon}
                      </Box>

                      <Box>
                        <Typography
                          variant="h5"
                          sx={{
                            fontWeight: 700,
                            color: '#1a1a2e',
                            mb: 1
                          }}
                        >
                          {feature.title}
                        </Typography>
                        <Typography
                          sx={{
                            color: '#6c757d',
                            fontSize: '0.95rem',
                            lineHeight: 1.6
                          }}
                        >
                          {feature.description}
                        </Typography>
                      </Box>
                    </Stack>

                    <Divider sx={{ mb: 3 }} />

                    <Grid container spacing={1.5}>
                      {feature.items.map((item, idx) => (
                        <Grid item xs={6} key={idx}>
                          <Stack direction="row" spacing={1} alignItems="center">
                            <Box
                              sx={{
                                width: 6,
                                height: 6,
                                borderRadius: '50%',
                                background: feature.color
                              }}
                            />
                            <Typography
                              sx={{
                                fontSize: '0.85rem',
                                color: '#495057',
                                fontWeight: 500
                              }}
                            >
                              {item}
                            </Typography>
                          </Stack>
                        </Grid>
                      ))}
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>

      {/* BİK Uyumluluğu */}
      <Box
        sx={{
          background: 'linear-gradient(135deg, #0f0f23 0%, #1a1a2e 100%)',
          py: { xs: 8, md: 12 },
          position: 'relative',
          overflow: 'hidden'
        }}
      >
        {/* Dekoratif Blob */}
        <Box
          sx={{
            position: 'absolute',
            top: -100,
            left: -100,
            width: 400,
            height: 400,
            background: 'linear-gradient(135deg, #dc2626 0%, #991b1b 100%)',
            borderRadius: '40% 60% 70% 30% / 40% 50% 60% 50%',
            opacity: 0.1,
            filter: 'blur(80px)',
            animation: 'morph 10s ease-in-out infinite'
          }}
        />

        <Container maxWidth="xl" sx={{ position: 'relative', zIndex: 2 }}>
          <Grid container spacing={6} alignItems="center">
            <Grid item xs={12} md={6}>
              <Box
                sx={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: 80,
                  height: 80,
                  borderRadius: 3,
                  background: 'linear-gradient(135deg, #dc2626 0%, #991b1b 100%)',
                  color: 'white',
                  fontSize: '2.5rem',
                  mb: 3,
                  boxShadow: '0 8px 24px rgba(220, 38, 38, 0.4)'
                }}
              >
                <LegalIcon fontSize="large" />
              </Box>

              <Typography
                variant="h2"
                sx={{
                  fontSize: { xs: '2.5rem', md: '3rem' },
                  fontWeight: 800,
                  color: 'white',
                  mb: 3
                }}
              >
                Basın İlan Kurumu{' '}
                <span style={{ color: '#dc2626' }}>Uyumluluğu</span>
              </Typography>

              <Typography
                sx={{
                  color: 'rgba(255,255,255,0.7)',
                  fontSize: '1.05rem',
                  lineHeight: 1.8,
                  mb: 4
                }}
              >
                Resmi ilan yayını için gerekli tüm standartlara uygun altyapı. 
                BİK raporlama ve arşivleme sistemleri entegre.
              </Typography>

              {/* BİK Features */}
              <Stack spacing={3}>
                {bikFeatures.map((feature, idx) => (
                  <Stack key={idx} direction="row" spacing={2} alignItems="start">
                    <Box
                      sx={{
                        width: 50,
                        height: 50,
                        borderRadius: 2,
                        background: feature.color,
                        color: 'white',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '1.5rem',
                        flexShrink: 0,
                        boxShadow: `0 4px 16px ${feature.color}40`
                      }}
                    >
                      {feature.icon}
                    </Box>
                    <Box>
                      <Typography
                        sx={{
                          fontWeight: 700,
                          color: 'white',
                          mb: 0.5
                        }}
                      >
                        {feature.title}
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: '0.9rem',
                          color: 'rgba(255,255,255,0.7)',
                          lineHeight: 1.6
                        }}
                      >
                        {feature.description}
                      </Typography>
                    </Box>
                  </Stack>
                ))}
              </Stack>

              {/* <Button
                variant="outlined"
                size="large"
                endIcon={<ArrowIcon />}
                sx={{
                  mt: 4,
                  borderColor: '#dc2626',
                  color: '#dc2626',
                  px: 5,
                  py: 2,
                  borderRadius: '50px',
                  textTransform: 'none',
                  fontSize: '1rem',
                  fontWeight: 600,
                  borderWidth: 2,
                  '&:hover': {
                    background: 'rgba(220, 38, 38, 0.1)',
                    borderWidth: 2
                  }
                }}
              >
                BİK Detayları
              </Button> */}
            </Grid>

            <Grid item xs={12} md={6}>
              <Box
                sx={{
                  position: 'relative',
                  borderRadius: 4,
                  overflow: 'hidden',
                  boxShadow: '0 20px 60px rgba(0,0,0,0.5)',
                  border: '2px solid rgba(255,255,255,0.1)'
                }}
              >
                <img
                  src="https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=700&h=500&fit=crop"
                  alt="BİK Compliance"
                  style={{
                    width: '100%',
                    height: 'auto',
                    display: 'block'
                  }}
                />

                {/* Overlay Info */}
                <Box
                  sx={{
                    position: 'absolute',
                    bottom: 20,
                    left: 20,
                    right: 20,
                    background: 'rgba(255,255,255,0.95)',
                    backdropFilter: 'blur(10px)',
                    borderRadius: 3,
                    p: 3,
                    boxShadow: '0 8px 24px rgba(0,0,0,0.2)'
                  }}
                >
                  <Stack direction="row" spacing={2} alignItems="center">
                    <Box
                      sx={{
                        width: 60,
                        height: 60,
                        borderRadius: 2,
                        background: 'linear-gradient(135deg, #dc2626 0%, #991b1b 100%)',
                        color: 'white',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '1.8rem'
                      }}
                    >
                      <VerifiedIcon fontSize="large" />
                    </Box>
                    <Box>
                      <Typography sx={{ fontWeight: 700, color: '#1a1a2e', mb: 0.5 }}>
                        BİK Onaylı Sistem
                      </Typography>
                      <Typography sx={{ fontSize: '0.9rem', color: '#6c757d' }}>
                        Tüm standartlara uygun resmi ilan yayını
                      </Typography>
                    </Box>
                  </Stack>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>

      {/* Ödeme Yöntemleri */}
      <Box
        sx={{
          background: 'linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%)',
          py: { xs: 8, md: 12 }}
        }
      >
        <Container maxWidth="lg">
          <Box sx={{ textAlign: 'center', mb: 6 }}>
            <Typography
              variant="h3"
              sx={{
                fontSize: { xs: '2rem', md: '2.5rem' },
                fontWeight: 800,
                color: '#1a1a2e',
                mb: 2
              }}
            >
              Güvenli Ödeme Yöntemleri
            </Typography>
            <Typography
              sx={{
                color: '#6c757d',
                fontSize: '1rem'
              }}
            >
              Size uygun ödeme yöntemini seçin
            </Typography>
          </Box>

          <Grid container spacing={3}>
            {paymentMethods.map((method, index) => (
              <Grid item xs={6} sm={4} md={2} key={index}>
                <Paper
                  sx={{
                    p: 3,
                    textAlign: 'center',
                    borderRadius: 3,
                    border: '2px solid #e2e8f0',
                    transition: 'all 0.3s ease',
                    cursor: 'pointer',
                    '&:hover': {
                      borderColor: '#10b981',
                      transform: 'translateY(-8px)',
                      boxShadow: '0 12px 32px rgba(16, 185, 129, 0.2)'
                    }
                  }}
                >
                  <Box sx={{ fontSize: '3rem', mb: 2 }}>
                    {method.icon}
                  </Box>
                  <Typography
                    sx={{
                      fontWeight: 600,
                      fontSize: '0.85rem',
                      color: '#1a1a2e'
                    }}
                  >
                    {method.name}
                  </Typography>
                </Paper>
              </Grid>
            ))}
          </Grid>

          {/* Güvenlik Garantisi */}
          <Box
            sx={{
              mt: 6,
              p: 4,
              borderRadius: 4,
              background: 'linear-gradient(135deg, rgba(16, 185, 129, 0.05), rgba(4, 120, 87, 0.05))',
              border: '2px solid #10b981',
              textAlign: 'center'
            }}
          >
            <Stack direction="row" spacing={2} justifyContent="center" alignItems="center" flexWrap="wrap" useFlexGap>
              <SecurityIcon sx={{ color: '#10b981', fontSize: '2rem' }} />
              <Typography sx={{ fontWeight: 700, color: '#1a1a2e', fontSize: '1.1rem' }}>
                256-bit SSL Şifreleme
              </Typography>
              <Typography sx={{ color: '#6c757d' }}>•</Typography>
              <Typography sx={{ fontWeight: 700, color: '#1a1a2e', fontSize: '1.1rem' }}>
                PCI DSS Uyumlu
              </Typography>
              <Typography sx={{ color: '#6c757d' }}>•</Typography>
              <Typography sx={{ fontWeight: 700, color: '#1a1a2e', fontSize: '1.1rem' }}>
                3D Secure
              </Typography>
            </Stack>
          </Box>
        </Container>
      </Box>

      {/* CTA Section */}
     <Container maxWidth="md">
     <Box
        sx={{
          my: 10,
          background: 'linear-gradient(135deg, #10b981 0%, #047857 100%)',
          py: { xs: 5, md: 3 },
          position: 'relative',
          overflow: 'hidden'
        }}
      >
        {/* Pattern */}
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundImage: 'radial-gradient(circle, rgba(255,255,255,0.1) 1px, transparent 1px)',
            backgroundSize: '30px 30px',
            opacity: 0.5
          }}
        />

        <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 2 }}>
          <Box sx={{ textAlign: 'center' }}>
            <Typography
              variant="h2"
              sx={{
                fontSize: { xs: '2.5rem', md: '3.5rem' },
                fontWeight: 800,
                color: 'white',
                mb: 3
              }}
            >
              Gelir Modelinizi Oluşturun
            </Typography>

            <Typography
              variant="h5"
              sx={{
                color: 'rgba(255,255,255,0.95)',
                mb: 5,
                maxWidth: 700,
                mx: 'auto',
                lineHeight: 1.6
              }}
            >
              30 gün ücretsiz deneme ile abonelik sistemini test edin. 
              Kredi kartı gerektirmez.
            </Typography>

            <Stack
              direction={{ xs: 'column', sm: 'row' }}
              spacing={3}
              sx={{ justifyContent: 'center' }}
            >
              <Button
                variant="contained"
                size="large"
                endIcon={<ArrowIcon />}
                sx={{
                  background: 'white',
                  color: '#10b981',
                  px: 6,
                  py: 2.5,
                  fontSize: '1.2rem',
                  fontWeight: 700,
                  borderRadius: '50px',
                  textTransform: 'none',
                  boxShadow: '0 8px 32px rgba(0,0,0,0.2)',
                  '&:hover': {
                    background: '#f8f9fa',
                    transform: 'translateY(-2px)',
                    boxShadow: '0 12px 40px rgba(0,0,0,0.3)'
                  }
                }}
              >
                Ücretsiz Başla
              </Button>

              <Button
                variant="outlined"
                size="large"
                sx={{
                  borderColor: 'white',
                  color: 'white',
                  px: 6,
                  py: 2.5,
                  fontSize: '1.2rem',
                  fontWeight: 700,
                  borderRadius: '50px',
                  textTransform: 'none',
                  borderWidth: 2,
                  '&:hover': {
                    background: 'rgba(255,255,255,0.1)',
                    borderColor: 'white',
                    borderWidth: 2
                  }
                }}
              >
                Paketleri Karşılaştır
              </Button>
            </Stack>
          </Box>
        </Container>
      </Box>
     </Container>

      {/* CSS Animations */}
      <style jsx>{`
        @keyframes morph {
          0%, 100% {
            border-radius: 40% 60% 70% 30% / 40% 50% 60% 50%;
          }
          25% {
            border-radius: 60% 40% 50% 50% / 30% 60% 40% 60%;
          }
          50% {
            border-radius: 50% 50% 30% 70% / 50% 30% 70% 40%;
          }
          75% {
            border-radius: 30% 70% 60% 40% / 60% 40% 50% 50%;
          }
        }
      `}</style>
    </Box>
  );
};

export default SubscriptionRevenuePage;